export default "__VITE_ASSET__CHAI80Hg__"